export const TOKEN_API = import.meta.env.VITE_TOKEN_API;
export const LOGO_API_KEY = import.meta.env.VITE_LOGO_API_KEY;
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;
export const SEGMENT_WRITE_KEY = import.meta.env.VITE_SEGMENT_WRITE_KEY;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

function trimmedEnv(value: string | undefined): string {
  return typeof value === "string" ? value.trim() : "";
}

/**
 * Sentry `environment` tag. Set `VITE_SENTRY_ENVIRONMENT` per deploy (e.g. production vs preview);
 * otherwise falls back to Vite `MODE`.
 */
export const SENTRY_ENVIRONMENT: string =
  trimmedEnv(import.meta.env.VITE_SENTRY_ENVIRONMENT) || import.meta.env.MODE;

/**
 * Optional Sentry release (commit SHA, CI build id). Enables issue ↔ source map linkage when set at build time.
 */
export const SENTRY_RELEASE: string | undefined = (() => {
  const v = trimmedEnv(import.meta.env.VITE_SENTRY_RELEASE);
  return v.length > 0 ? v : undefined;
})();